import Vue from 'vue'
import App from './App.vue'
import VueRouter from 'vue-router'
import router from './router'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import VueWechatTitle from 'vue-wechat-title'
import Vue2Editor from "vue2-editor"
import VueScrollReveal from 'vue-scroll-reveal';
import './common/style.scss'
import './common/reset.scss'
import './common/el-recover.scss'
import './common/animate.min.css'
import './utils/resize_text.js'
Vue.config.productionTip = false
Vue.use(VueRouter)
Vue.use(ElementUI)
Vue.use(VueWechatTitle)
Vue.use(Vue2Editor)
/**
 * 使用anim动画库 配合scrollReveal插件
 * 使用方法：自定义指令  v-scroll-reveal={option} 或者 v-scroll-reveal.reset={option}
 */
Vue.use(VueScrollReveal)


new Vue({
  render: h => h(App),
  router: router,
  beforeCreate() {
    Vue.prototype.$bus = this //安装全局事件总线(bus加$是为了符合Vue的代码设计规范)
    //Vue.prototype.$axios = axios
  }
}).$mount('#app')
